<fr8bot-ui-icon [name]="icon()" [size]="32" />
<span class="typography-small-text">{{ text() }}</span>
